module.exports = __webpack_public_path__ + "static/img/team_member_alan.fd65d34d.png";